import { Component, inject, Input, OnInit } from '@angular/core';
import { FeiertagService } from 'lion-api';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-verfuegbarkeit',
  standalone: false,
  templateUrl: './form-verfuegbarkeit.component.html',
  styleUrl: './form-verfuegbarkeit.component.scss'
})
export class FormVerfuegbarkeitComponent implements OnInit {
  @Input() attachForm?: FormGroup;
  @Input() isDzBankUser?: boolean;

  protected overNightDate?: Date;
  protected tomorrowDate?: Date;
  protected spotDate?: Date;

  private holidayService = inject(FeiertagService);

  ngOnInit(): void {
    this.initializeAvailableDays();
  }

  private initializeAvailableDays() {
    this.holidayService.availabilityDaysGET().subscribe({
      next: (response) => {
        this.overNightDate = response.overnightDate;
        this.tomorrowDate = response.tomorrowDate;
        this.spotDate = response.spotDate;
      }
    });
  }
}
